<template>
    <v-container fluid>
      <v-row align="center" justify="center" style="height: 90vh" dense>
        <v-col sm="12" xl="8" lg="8" md="12" >
          <v-card elevation="2">
            <v-row class="lighten-3">
              <v-col xl="5" lg="5" md="5" sm="5" v-if="$vuetify.breakpoint.smAndUp" align-self="center">
                <v-img contain :src="require('../../assets/logo.png')" />
              </v-col>
              <v-col lg="7" md="7" xs="12" class="lighten-4">
                <v-card-title class="text-h4 mb-1 font-weight-bold">Welcome back</v-card-title>
                <v-card-subtitle class="font-weight-bold">Welcome back, Please enter your details.</v-card-subtitle>
                <v-card-text>
                  <v-col xl="9" lg="9" md="10" sm="10" class="py-0 px-0">
                    <v-text-field v-model="form.email" outlined label="Email" prepend-inner-icon="mdi-email"
                      :error-messages="errors.email"></v-text-field>
                  </v-col>
                  <v-col xl="9" lg="9" md="10" sm="10" class="py-0 px-0">
                    <v-text-field @keypress.enter="login" v-model="form.password" type="password" outlined
                      label="Password" prepend-inner-icon="mdi-lock" :error-messages="errors.password"></v-text-field>
                  </v-col>
                  <v-btn :loading="Loading" color="green" dark @click="login"> Login </v-btn>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "LoginPage",
  data() {
    return {
      form: {
        email: "",
        password: "",
        portal: true,
      },
      loggedInRole: "",
      Loading: false
    };
  },
  methods: {
    ...mapActions({
      logIn: "auth/logIn",
    }),
    async login() {
      this.Loading = true;
      await this.logIn(this.form)
        .then(() => {
          location.reload("/");
          this.Loading = false;
        })
        .catch(() => {
          alert("User can't login in portal");
          this.Loading = false;
        });
      this.Loading = false;
    },
  },
};
</script>
